<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة استشارة محامي</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/lawyerReq">استشارات المحامين</router-link></li>
              <li class="breadcrumb-item active">إضافة استشارة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة استشارة محامي</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSuccess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div class="fw-bold">{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الاسم: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="name">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">رقم الجوال: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="mobile">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">موضوع الاستشارة: <span class="req">*</span></label>
                      <textarea class="form-control" rows="4" v-model="subject" placeholder="أدخل تفاصيل الاستشارة المطلوبة..."></textarea>
                    </div>
                  </div>

                  <!-- attachments -->
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">ارفاق مستندات:</label>
                      <input
                        type="file"
                        class="form-control"
                        multiple
                        accept="image/*,application/pdf"
                        @change="setAttachments($event.target.files)"
                      >
                      <div class="form-text">يمكنك رفع أكثر من ملف (صور أو PDF)</div>
                      <!-- preview selected files -->
                      <ul v-if="attachments.length" class="list-unstyled mt-2 mb-0">
                        <li v-for="(f, i) in attachments" :key="i" class="text-muted small">
                          <i class="bi bi-paperclip me-1"></i>{{ f.name }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">ملاحظات الإدارة:</label>
                      <textarea class="form-control" rows="2" v-model="adminNote" placeholder="ملاحظات..."></textarea>
                    </div>
                  </div>

                  <div class="alert alert-info">
                    <i class="bi bi-info-circle me-1"></i>
                    سيتم إضافة الطلب بحالة "بانتظار السداد" ويمكن تعديلها لاحقاً.
                  </div>
                </div>

                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'LawyerReqsCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      name: null,
      mobile: null,
      subject: null,
      adminNote: null,
      attachments: [],
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          if(!this.name) this.name = data.user.name;
          if(!this.mobile) this.mobile = data.user.mobile;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    submitData(){
      this.hasError = false;
      this.hasSuccess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.name || !this.mobile || !this.subject){
        this.message = 'يرجى تعبئة الاسم ورقم الجوال وموضوع الاستشارة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      const formData = new FormData();
      formData.append('userId',    this.userId);
      formData.append('name',      this.name);
      formData.append('mobile',    this.mobile);
      formData.append('subject',   this.subject);
      if(this.adminNote)
        formData.append('adminNote', this.adminNote);
      this.attachments.forEach(file => {
        formData.append('attachments', file);
      });

      this.$http.post('/api/admin/lawyerReq/create', formData).then(({data}) => {
        toast('تم إضافة الاستشارة بنجاح', 'success');
        this.$router.push(`/lawyerReq/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError   = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setAttachments(files){
      this.attachments = Array.from(files);
    },
  },
}
</script>